module.exports = __webpack_public_path__ + "static/media/o-brain.bcb8d682.png";